import { InformationCircleIcon } from "@heroicons/react/24/outline";

export default function ChartCard({ title, className = "", children }) {
  return (
    <div className={`overflow-hidden rounded-2xl bg-white shadow-lg ${className}`}>
      <div className="flex items-center border-b border-gray-200 px-6 py-4 md:justify-between lg:px-8 lg:py-6">
        <div className="min-w-0 flex-1">
          <h2 className="flex items-center text-lg font-bold text-gray-900 sm:text-xl">
            {title} <InformationCircleIcon aria-hidden="true" className="ms-1 size-6" />
          </h2>
        </div>
      </div>
      {children}
    </div>
  );
}
